var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKuroKBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_419",
    "data-name": "Group 419",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 104.219,
    viewBox: "0 0 98 104.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M63.46,5.8C65.472,4.638,90.6-.744,91.939.088S23.284,94.615,20.667,97.048.287,102.468,0,101.195,61.457,6.965,63.46,5.8",
    transform: "translate(0 -0.001)",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M30.416,62.472c-.78-2.11,11.647-18.119,11.647-18.119s14.5-19.119,16.387-20.147S70.1,25.06,69.793,26.83,49.65,53.034,52.819,59.238,81.865,90.6,81.478,91.158,60.53,88.134,59.264,87.371,31.2,64.587,30.416,62.472",
    transform: "translate(16.518 13.002)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuroKBlack);
export default __webpack_public_path__ + "static/media/kuroKBlack.3933c3e3538418861cb13a908f1e2154.svg";
export { ForwardRef as ReactComponent };